export default __webpack_public_path__ + "static/6832-fb03255704bc79f23fd3b4891901acfb.jpg";